import { Col, Form, Radio, Row } from "antd";
import TextArea from "antd/lib/input/TextArea";
import React from "react";
import { useTranslation } from "react-i18next";
import { RISK_TYPES } from "../../../../../constants/constants";
import { FormSectionProps } from "../../../../../models/form-section.model";
import { ScenarioModel } from "../../../../../models/scenario.model";
import { VALIDATION_UTIL } from "../../../../../utils/validation.utils";


const RiskTypeSection = (props: FormSectionProps<ScenarioModel>) => {

    const { t } = useTranslation();

    return (
        <div className="section-wrapper">
            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("Scenario.lbPleaseSelectOne")}
                        name="risk_type"
                        rules={VALIDATION_UTIL.getRulesValidationField("risk_type", props.requiredFields)}
                    >
                        <Radio.Group>
                            <Row gutter={[15, 10]}>
                                {
                                    RISK_TYPES.map((item, index) => (
                                        <Col span={12} key={index}>
                                            <Radio value={item.value}>{item.name}</Radio>
                                        </Col>
                                    ))
                                }
                            </Row>
                        </Radio.Group>
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 24]}>
                <Col span={24}>
                    <Form.Item
                        label={t("Scenario.lbDescriptionOfOverlap")}
                        name="description_of_overlap"
                        rules={VALIDATION_UTIL.getRulesValidationField("description_of_overlap", props.requiredFields)}
                    >
                        <TextArea rows={5} maxLength={150} placeholder={t("Scenario.plDescriptionOfOverlap")} />
                    </Form.Item>
                </Col>
            </Row>

        </div>
    )
}

export default RiskTypeSection;